export enum XpressDisciplinaryPeriodEnum {
    None = 0,
    OneDay = 1,
    ThreeDays = 2,
    SevenDays = 3,
    ThirtyDays = 4
}
